import { OdataFilters, queryCollection } from "helpers/reqparams";
import { request } from "services/request";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(`api/bids/getlist?${query.substring(1)}`, { method: "GET" }, { countInHeaders: true });
};

export { index };
